module.exports = __webpack_public_path__ + "img/Legends-Hoodie-01.b54d76a1.jpg";